<template>
  <div
    class="bg-blue-DEFAULT min-h-screen p-4 flex flex-col sm:block sm:h-screen sm:sticky sm:top-0 scrol"
    v-if="isLoading"
    v-on:scroll.stop
  >
    <Spinner/>
  </div>
  <div
    class="bg-blue-DEFAULT min-h-screen p-4 flex flex-col sm:block sm:h-screen sm:sticky sm:top-0 scroll"
    v-on:scroll.stop
    v-else
  >
    <div class="mb-4 flex justify-end">
      <button @click="handleClickCloseSidebar">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-light" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <div class="mb-6 flex justify-between">
      <input
        autofocus
        class="w-4/6 py-2 px-3 block sm:text-sm bg-blue-DEFAULT text-gray-light border border-gray-DEFAULT focus:outline-none focus:border-gray-light"
        type="text"
        v-model="search"
        placeholder="Search location"
      >
      <button
        @click="handleSearchLocation"
        class="px-1 w-1/4 bg-blue-light text-gray-light"
      >
        Search
      </button>
    </div>
    <ul>
      <li
        @click="handleChangeLocation(location.locationID)"
        v-for="location in searchedGeolocations"
        :key="location.locationID"
        class="p-3 mb-3 flex justify-between items-center border border-transparent text-gray-light cursor-pointer last:mb-0 hover:border-gray-dark"
      >
        {{location.locationName}}
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-transparent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </li>
    </ul>
  </div>
</template>

<script>
import Spinner from "./spinner";
import { mapState } from "vuex";

export default {
  name: "Sidebar",
  data () {
    return {
      isLoading: false,
      search: "",
    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState(["searchedGeolocations", "isSidebarOpen"])
  },
  methods: {
    handleClickCloseSidebar () {
      this.$store.dispatch("closeSidebar");
    },
    async handleSearchLocation () {
      try {
        this.isLoading = true;
        await this.$store.dispatch("getGeoLocationIDByName", this.search);
      } catch (e) {
        this.$toast.error(e.message);
      } finally {
        this.isLoading = false;
      }
    },
    async handleChangeLocation (locationID) {
      try {
        this.$store.dispatch("closeSidebar");
        await this.$store.dispatch("changeLocation", locationID);
      } catch (error) {
        console.warn(error);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
li:hover > svg {
  color: #6E707A;
}
</style>
